import { render, staticRenderFns } from "./personInChargeUpload.vue?vue&type=template&id=21745b9a"
import script from "./personInChargeUpload.vue?vue&type=script&lang=js"
export * from "./personInChargeUpload.vue?vue&type=script&lang=js"
import style0 from "./personInChargeUpload.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports